import React from 'react';
import { TrendingDown, AlertTriangle, CheckCircle2, Activity } from 'lucide-react';

const ICONS = {
  executed: { icon: <CheckCircle2 size={16} />, color: 'var(--profit)' },
  failed:   { icon: <AlertTriangle size={16} />, color: 'var(--loss)' },
  skipped:  { icon: <Activity size={16} />, color: 'var(--text-tertiary)' },
  pending:  { icon: <Activity size={16} />, color: 'var(--warning)' },
  closed:   { icon: <TrendingDown size={16} />, color: 'var(--text-secondary)' },
  default:  { icon: <Activity size={16} />, color: 'var(--text-secondary)' },
};

function relTime(d) {
  const ms = Date.now() - new Date(d).getTime();
  const m = Math.round(ms / 60000);
  if (m < 1) return 'just now';
  if (m < 60) return `${m}m ago`;
  const h = Math.round(m / 60);
  if (h < 24) return `${h}h ago`;
  return new Date(d).toLocaleDateString();
}

/**
 * Real-time activity feed. items = array of:
 *   { _id, status, traderId:{email}, copierId:{email}, scaledLots, createdAt }
 */
export default function ActivityFeed({ items, empty = 'No recent activity.' }) {
  if (!items || items.length === 0) {
    return <div style={{ padding: 24, color: 'var(--text-secondary)', fontSize: 13 }}>{empty}</div>;
  }
  return (
    <div className="ct-activity">
      {items.map(e => {
        const meta = ICONS[e.status] || ICONS.default;
        const trader = e.traderId?.username || e.traderId?.email || '—';
        const copier = e.copierId?.username || e.copierId?.email || '—';
        return (
          <div className="row" key={e._id}>
            <div className="icon" style={{ color: meta.color }}>{meta.icon}</div>
            <div className="body">
              <div className="title">
                <strong>{copier}</strong>
                <span style={{ color: 'var(--text-tertiary)' }}> copied </span>
                <strong>{trader}</strong>
              </div>
              <div className="meta">
                {e.status} · {e.scaledLots != null ? `${e.scaledLots} lots` : '—'} · {relTime(e.createdAt)}
              </div>
            </div>
            <div className="right" style={{ color: meta.color }}>
              {e.scaledLots != null ? Number(e.scaledLots).toFixed(2) : ''}
            </div>
          </div>
        );
      })}
    </div>
  );
}
